
import styled from "styled-components";
import { useEffect } from "react";
import React from 'react';
import { AreaChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Area } from 'recharts';
import { useFetch } from "../../../api/useFetch";
import { useUserContext } from "../../../context/user_context";
import MiniLoader from "../../../utils/MIniLoader";

const OverviewChart = ({ endpoint }) => {
      const { btoken, stoken } = useUserContext();
      let data = {
            btoken, stoken, year: "2025"
      };

      const {
            loading: chartLoading,
            data: chartData,
            fetchData: getChartData
      } = useFetch(`${ endpoint }`, data);

      useEffect(() => {
            getChartData();
      }, []);

      return (
            <StyledOverviewChart className="h-100">
                  <div className="main-container">

                        <div className="d-flex gap-2">

                              <h4 className="mb-4 grey-bold-text">
                                    Overview Chart
                              </h4>
                              <MiniLoader
                                    load={chartLoading}
                              />
                        </div>
                        <ResponsiveContainer width="100%" height={350}>
                              <AreaChart
                                    width={500}
                                    height={300}
                                    data={chartData}
                                    margin={{
                                          top: 5,
                                          right: 30,
                                          left: 20,
                                          bottom: 5,
                                    }}
                              >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="month" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Area type="monotone" dataKey="expense" stroke="#667085" fill="#66708521" />
                                    <Area type="monotone" dataKey="sale" stroke="#529af7" activeDot={{ r: 8 }} fill="#B6D3FA21" />

                              </AreaChart>
                        </ResponsiveContainer>
                  </div>

                  {/* <Area type="monotone" dataKey="expense" stroke="#DBA362CC" fill="#dba36221" />
                                    <Area type="monotone" dataKey="expense" stroke="#FF0000" fill="#FF000021" />
                                    <Area type="monotone" dataKey="expense" stroke="#845EBC" fill="#845EBC21" /> */}

            </StyledOverviewChart>
      );
};

export default OverviewChart;

const StyledOverviewChart = styled.div`


`;
